import React from "react";
import "./page.css";
import {
  Button,
  TextField,
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Divider,
} from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";

import InputFamily from "../components/InputFamily";
import DisabledFamily from "../components/DisabledFamily";

import Tutrial from "../components/Tutrial";
import TutrialImage1 from "../asset/tutrial/ins/tutrial1.gif";
import TutrialImage2 from "../asset/tutrial/ins/tutrial2.jpg";

import {
  NumberFormatCustom,
  NumberFormatCustomHundred,
} from "../components/NumberFormatCustom.js";
import handleUpdate from "../functions/handleUpdate";
import { connect } from "react-redux";
import {
  changeSougaku,
  changeHaiguusha,
  changeChild,
} from "../actions/actions";

import ReactFC from "react-fusioncharts";
import FusionCharts from "fusioncharts";
import Column2D from "fusioncharts/fusioncharts.charts";
import FusionTheme from "fusioncharts/themes/fusioncharts.theme.fusion";

import { calculate, zeigaku } from "../functions/CalculateSouzoku.js";
import { LogoCover } from "../components/LogoCover";

import firebase from "../firebase";

ReactFC.fcRoot(FusionCharts, Column2D, FusionTheme);

const dataSource = {
  chart: {
    numberSuffix: "万円",
    theme: "fusion",
    formatNumberScale: 0,
    showPlotBorder: 0,
    usePlotGradientColor: 0,
    valueFontBold: 1,
    //bgColor: "#fff",
    canvasBgColor: "#fff",
    showXAxisLine: true,
    showYAxisLine: true,
  },
  data: [
    {
      label: "保険金額",
      value: "",
      color: "#1d8f6e",
    },
    {
      label: "相続税減少額",
      value: "",
      color: "#5679cc",
    },
  ],
};

const chartConfigs = {
  type: "column2d", // The chart type
  width: "100%", // Width of the chart
  height: "400", // Height of the chart
  dataFormat: "json", // Data type
  dataSource: dataSource,
};

function calculate_zeisougaku(isansougaku, haiguusha, child) {
  const kisoKoujyo = 3000 + 600 * (child + haiguusha);
  let kazeiIsangaku = Number(isansougaku) * 100 - kisoKoujyo;
  if (kazeiIsangaku <= 0) {
    kazeiIsangaku = 0;
  }
  let haiguusha_kazeiIsangaku,
    child_kazeiIsangaku,
    zeiSougaku = 0;
  if (haiguusha === 1) {
    haiguusha_kazeiIsangaku = kazeiIsangaku / 2;
    child_kazeiIsangaku = kazeiIsangaku / 2 / child;
    zeiSougaku = Math.round(
      (zeigaku(haiguusha_kazeiIsangaku)[0] +
        zeigaku(child_kazeiIsangaku)[0] * child) /
      2
    );
  } else if (haiguusha === 0) {
    haiguusha_kazeiIsangaku = 0;
    child_kazeiIsangaku = kazeiIsangaku / child;
    zeiSougaku = Math.round(zeigaku(child_kazeiIsangaku)[0] * child);
  }

  return zeiSougaku;
}

class Insurance extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: dataSource,
      gendo: 1000,
      hikazeiwaku: "1000",
      open: false,
      calculationCount: 0,
      tutrial: false 
    };
  }

  handleOpen() {
    this.setState({ open: true });
  }

  handleClose() {
    this.setState({ open: false });
  }

  AlertDialog() {
    return (
      <Dialog open={this.state.open} onClose={this.handleClose}>
        <DialogTitle>限度額を超えています</DialogTitle>
        <DialogActions>
          <Button onClick={this.handleClose} color="primary" autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  componentDidMount() {
    // const analytics = firebase.analytics();
    // analytics.logEvent('screen_view', { "screen_name": '非課税枠の効果' });
    //console.log('send log');
    const gendo = (this.props.haiguusha + this.props.child) * 500;

    dataSource.data[0].value = this.state.hikazeiwaku;
    dataSource.data[1].value =
      Number(
        calculate_zeisougaku(
          this.props.sougaku,
          this.props.haiguusha,
          this.props.child
        )
      ) -
      Number(
        calculate_zeisougaku(
          this.props.sougaku - this.state.hikazeiwaku / 100,
          this.props.haiguusha,
          this.props.child
        )
      );
    this.setState({ gendo: gendo });
    this.setState({ dataSource: dataSource });

    const ended = localStorage.getItem("tutrial1");
    // console.log("ended: ", ended);
    if (ended) {
      this.setState({ tutrial: false });
    } else {
      this.setState({ tutrial: true });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    //console.log('start update checking top');
    handleUpdate();
    const analytics = firebase.analytics();
    const gendo = (this.props.haiguusha + this.props.child) * 500;
    if (
      this.props.sougaku !== prevProps.sougaku ||
      this.state.hikazeiwaku !== prevState.hikazeiwaku ||
      this.props.haiguusha !== prevProps.haiguusha ||
      this.props.child !== prevProps.child ||
      this.state.gendo !== prevState.gendo
    ) {
      let dataSource = this.state.dataSource;
      dataSource.data[0].value = this.state.hikazeiwaku;
      dataSource.data[1].value =
        Number(
          calculate_zeisougaku(
            this.props.sougaku,
            this.props.haiguusha,
            this.props.child
          )
        ) -
        Number(
          calculate_zeisougaku(
            this.props.sougaku - this.state.hikazeiwaku / 100,
            this.props.haiguusha,
            this.props.child
          )
        );
      this.setState({ gendo: gendo });
      this.setState({ dataSource: dataSource });
      analytics.logEvent("calculation");
      this.setState({ calculationCount: this.state.calculationCount + 1 });
      if (this.state.calculationCount % 10 === 0) {
        //console.log("calculate 10 times :", this.state.calculationCount);
        analytics.logEvent("calculate10times");
      }
    }
    if (
      this.props.haiguusha !== prevProps.haiguusha ||
      this.props.child !== prevProps.child ||
      this.state.gendo !== prevState.gendo
    ) {
      this.setState({ hikazeiwaku: String(gendo) });
    }
    if (this.state.hikazeiwaku !== prevState.hikazeiwaku) {
      if (this.state.hikazeiwaku > gendo) {
        //this.handleOpen();
        //this.setState({ open: true });
        //console.log('this.state.open:', this.state.open);
        alert("限度額を超えています");
        this.setState({ hikazeiwaku: gendo });
      }
    }
  }

  closeTutrial = () => {
    localStorage.setItem("tutrial1", "ended");
    this.setState({ tutrial: false })
  };

  render() {
    return (
      <>
        {this.state.tutrial ? <Tutrial closeTutrial={this.closeTutrial} image1={TutrialImage1} image2={TutrialImage2} /> :
          <div className="container">
            <section className="userArea">
              <div className="input">
                <TextField
                  label="課税遺産額"
                  onChange={(event) => this.props.changeSougaku(event.target.value)}
                  value={`${this.props.sougaku}`}
                  InputProps={{
                    inputComponent: NumberFormatCustomHundred,
                    type: 'tel'
                  }}
                  fullWidth={true}
                  color={"secondary"}
                />
              </div>
              {this.props.isPaid && !this.props.needEmailVerify ? <InputFamily
                haiguusha={this.props.haiguusha}
                changeHaiguusha={this.props.changeHaiguusha}
                child={this.props.child}
                changeChild={this.props.changeChild}
              /> : <DisabledFamily
                haiguusha={this.props.haiguusha}
                child={this.props.child}
              />}
              <div className="gendo">
                <TableContainer>
                  <Table>
                    <TableBody>
                      <TableRow>
                        <TableCell component="th" scope="row">
                          保険金非課税限度額
                        </TableCell>
                        <TableCell align="right">{this.state.gendo} 万円</TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
              <div className="input">
                <TextField
                  label="実際の非課税適用額"
                  onChange={(event) =>
                    this.setState({ hikazeiwaku: event.target.value })
                  }
                  value={`${this.state.hikazeiwaku}`}
                  InputProps={{
                    inputComponent: NumberFormatCustom,
                    type: 'tel'
                  }}
                  fullWidth={true}
                  color={"secondary"}
                />
              </div>
            </section>
            <Divider style={{ backgroundColor: "#cfd8dc" }} />
            <section className="resultArea">
              <div className="listContainer">
                <div className="listTitle">非課税枠適用前</div>
                <TableContainer>
                  <Table>
                    <TableBody>
                      <TableRow>
                        <TableCell component="th" scope="row">
                          {
                            calculate(
                              this.props.sougaku,
                              this.props.haiguusha,
                              this.props.child
                            )[0][1].name
                          }
                        </TableCell>
                        <TableCell align="right">
                          {
                            calculate(
                              this.props.sougaku,
                              this.props.haiguusha,
                              this.props.child
                            )[0][1].value
                          }
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell component="th" scope="row">
                          {
                            calculate(
                              this.props.sougaku,
                              this.props.haiguusha,
                              this.props.child
                            )[0][2].name
                          }
                        </TableCell>
                        <TableCell align="right">
                          {
                            calculate(
                              this.props.sougaku,
                              this.props.haiguusha,
                              this.props.child
                            )[0][2].value
                          }
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
              <div className="listContainer">
                <div className="listTitle">非課税枠適用後</div>
                <TableContainer>
                  <Table>
                    <TableBody>
                      <TableRow>
                        <TableCell component="th" scope="row">
                          {
                            calculate(
                              this.props.sougaku - this.state.hikazeiwaku / 100,
                              this.props.haiguusha,
                              this.props.child
                            )[0][1].name
                          }
                        </TableCell>
                        <TableCell align="right">
                          {
                            calculate(
                              this.props.sougaku - this.state.hikazeiwaku / 100,
                              this.props.haiguusha,
                              this.props.child
                            )[0][1].value
                          }
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell component="th" scope="row">
                          {
                            calculate(
                              this.props.sougaku - this.state.hikazeiwaku / 100,
                              this.props.haiguusha,
                              this.props.child
                            )[0][2].name
                          }
                        </TableCell>
                        <TableCell align="right">
                          {
                            calculate(
                              this.props.sougaku - this.state.hikazeiwaku / 100,
                              this.props.haiguusha,
                              this.props.child
                            )[0][2].value
                          }
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
              <div className="listContainer" style={{ padding: 0 }}>
                <TableContainer>
                  <Table>
                    <TableBody>
                      <TableRow>
                        <TableCell component="th" scope="row">
                          保険加入による{this.props.haiguusha ? "一次" : "二次"}
                          相続税減少額
                        </TableCell>
                        <TableCell align="right">
                          {Number(
                            calculate_zeisougaku(
                              this.props.sougaku,
                              this.props.haiguusha,
                              this.props.child
                            )
                          ) -
                            Number(
                              calculate_zeisougaku(
                                this.props.sougaku - this.state.hikazeiwaku / 100,
                                this.props.haiguusha,
                                this.props.child
                              )
                            )}{" "}
                          万円
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
              <div className="chartContainer">
                <ReactFC {...chartConfigs} />
                <LogoCover></LogoCover>
              </div>
            </section>
          </div>}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  sougaku: state.user.sougaku,
  haiguusha: state.user.haiguusha,
  child: state.user.child,
  isPaid: state.user.isPaid,
  needEmailVerify: state.user.needEmailVerify
});

const mapDispatchToProps = {
  changeSougaku,
  changeHaiguusha,
  changeChild,
};

export default connect(mapStateToProps, mapDispatchToProps)(Insurance);
